module.exports = __webpack_public_path__ + "img/empty_data2.74a6b641.svg";